import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { CBHero } from '../components/clear-brilliant/CBHero';
import { CBWhatIs } from '../components/clear-brilliant/CBWhatIs';
import { CBBenefits } from '../components/clear-brilliant/CBBenefits';
import { CBFractional } from '../components/clear-brilliant/CBFractional';
import { CBNextGen } from '../components/clear-brilliant/CBNextGen';
import { CBCombine } from '../components/clear-brilliant/CBCombine';
import { CBAddOns } from '../components/clear-brilliant/CBAddOns';
import { CBFAQ } from '../components/clear-brilliant/CBFAQ';
import { CBWhyChoose } from '../components/clear-brilliant/CBWhyChoose';
export function ClearBrilliantPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2454">
      <Navigation data-id="element-2455" />
      <main data-id="element-2456">
        <CBHero data-id="element-2457" />
        <CBWhatIs data-id="element-2458" />
        <CBBenefits data-id="element-2459" />
        <CBFractional data-id="element-2460" />
        <CBNextGen data-id="element-2461" />
        <CBCombine data-id="element-2462" />
        <CBAddOns data-id="element-2463" />
        <CBFAQ data-id="element-2464" />
        <CBWhyChoose data-id="element-2465" />
      </main>
      <Footer data-id="element-2466" />
    </div>;
}